import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { shortRegistrationRequest, shortRegistrationSuccess, shortRegistrationFailure } from '../reducers/login';
import { xapiRequest } from '../reducers/xapi';
import { API_LINK } from '../../constants';
import * as moment from 'moment';
const API = `${API_LINK}api/registerShortPage1`;

function* shortRegistrationFunctionAxios() {
 
  const state = yield select(fullState => fullState);
  
  const {
    email,
    password,
    firstname,
    maidenname,
    lastname,
    programCode,
    AmLeader,
    birthdate,
    identityNo,
    conTitleID,
    gender,
    cell,
    middlename,
    identitytype
  } = state.form.registration.values;
  
  const amLeader = state.form.registration.values.AmLeader ? 1 : 0;
  
  const response = yield call(() => {
    
    return axios({
      method: 'post',
      url: API,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      data: {
        birthdate: birthdate,
        firstname: firstname,
        middleName: middlename,
        lastname: lastname,
        email: email,
        password: password,
        programCode: programCode,
        amLeader: amLeader,
        identityNo: identityNo,
        cell: cell,
        conTitleID: conTitleID[0],
        gender: gender[0],
        maidenName: maidenname,
        identityType: identitytype[0],
        platform: 'web'
      },
    });
  });
  
  return response;
}

function* workerShortRegistrationSaga() {
  try {
    
    const response = yield call(shortRegistrationFunctionAxios);
    const responseFromLogin = response.data;
   
    if (response.status === 200) {
      yield put(shortRegistrationSuccess(responseFromLogin));
      yield put(xapiRequest({ xapiType: 'shortregistration' }));
    }
    if (response.status === 201) {
      yield put(shortRegistrationFailure(response.data));
    }
    if (response.status === 205) {
      yield put(shortRegistrationFailure('Email does not exist'));
    }
    if (response.status === 206) {
      yield put(shortRegistrationFailure(response.data));
    }
    if (response.status === 208) {
      yield put(shortRegistrationFailure(response.data));
    }
    if (response.status === 500) {
      yield put(shortRegistrationFailure(response.statusText));
    }
  } catch (error) {
    
    yield put(shortRegistrationFailure(error.error));
  }
}

export function* watcherShortRegistrationSaga() {
  yield takeLatest(shortRegistrationRequest().type, workerShortRegistrationSaga);
}
